import { useMemo } from "react";
import { useToken } from "@hightouch/htui";
import type { ReviewPdfLabelColors } from "src/pages/ad-studio/pdf-export/build-review-pdf";

/**
 * Canvas needs literal colors, so the PDF's label tokens resolve here, in React.
 * A canvas ignores a color it can't parse, so an unresolved token falls back to a literal.
 */
export function useReviewPdfLabelColors(): ReviewPdfLabelColors {
  const name: string = useToken("colors", "text.primary", "black");
  const dimensions: string = useToken("colors", "text.secondary", "gray");
  return useMemo(() => ({ name, dimensions }), [name, dimensions]);
}
